import get from "lodash/get";
import {
    getInvoiceClientLoading,
    getInvoiceClientReject,
    getInvoiceClientRequest,
    getInvoiceClientSuccess,
} from "../../actions/invoiceClient/getAll";

export const getInvoiceClient = (formData) => async (dispatch, getState) => {
    dispatch(getInvoiceClientLoading());
    try {
        const { data } = await getInvoiceClientRequest(formData, getState);
        dispatch(getInvoiceClientSuccess(data));
    } catch (error) {
        dispatch(getInvoiceClientReject(get(error, "response.data", error)));
    }
    return Promise.resolve();
};
